export const COMMIT_TAG_CONFIG = {
  Feature: { emoji: '🚀', color: 'border-transparent bg-blue-500/10 text-blue-500' },
  Bugfix: { emoji: '🐛', color: 'border-transparent bg-red-500/10 text-red-500' },
  Improvement: { emoji: '⚡️', color: 'border-transparent bg-green-500/10 text-green-500' },
  Chore: { emoji: '🧹', color: 'border-transparent bg-yellow-500/10 text-yellow-500' },
  Refactoring: { emoji: '🔧', color: 'border-transparent bg-purple-500/10 text-purple-500' },
} as const

export const ORDERED_COMMIT_TAGS = Object.keys(COMMIT_TAG_CONFIG) as Array<keyof typeof COMMIT_TAG_CONFIG>

export function resolveCommitTag(tag: string) {
  const normalized = tag.trim()
  const exact = COMMIT_TAG_CONFIG[normalized as keyof typeof COMMIT_TAG_CONFIG]
  if (exact) return { label: normalized, ...exact }

  const match = ORDERED_COMMIT_TAGS.find((known) => known.toLowerCase() === normalized.toLowerCase())
  if (match) return { label: match, ...COMMIT_TAG_CONFIG[match] }

  return {
    label: normalized,
    emoji: '',
    color: 'border-transparent bg-muted text-muted-foreground',
  }
}
